import { ColumnsType } from 'antd/es/table';

export const headerCapitalBranch: ColumnsType<any> = [
  {
    title: 'Mã chi nhánh',
    dataIndex: 'branch_code',
  },
  {
    title: 'Mã cửa hàng',
    dataIndex: 'shop_code',
  },
  {
    title: 'Tên cửa hàng',
    dataIndex: 'shop_name',
  },
  {
    title: 'Năm phân bổ',
    dataIndex: 'capital_year',
  },
  {
    title: 'Tên phân bổ',
    dataIndex: 'capital_name',
  },
  // {
  //   title: 'Chi nhánh phân bổ',
  //   dataIndex: 'capital_value',
  // },
  {
    title: 'Vốn phân bổ tối thiểu (min)',
    dataIndex: 'capital_min',
  },
  {
    title: 'Vốn phân bổ tối đa (max)',
    dataIndex: 'capital_max',
  },
  {
    title: 'Trạng thái',
    dataIndex: 'capital_branch_status',
  },
  {
    title: 'Ngày tạo',
    dataIndex: 'created_at',
  },
];
